import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import Hero from './components/Hero';
import Intro from './components/Intro';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import InspirationGallery from './components/InspirationGallery';
import BottomCTA from './components/BottomCTA';
import { productJsonLd } from '@/components/feature/ProductJsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://popprotents.com';

const jsonLd = productJsonLd({
  name: 'Bespoke Decor — Custom Event Styling & Tent Dressing | Pop Pro Tents',
  description: 'Elevate your event with bespoke decor services including custom draping, lighting, flooring, furniture, and full event styling. Designed to transform stretch tent interiors into stunning branded or themed environments.',
  url: `${siteUrl}/products/bespoke-decor`,
  category: 'Bespoke Event Decor',
});

export default function BespokeDecor() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <Services />
        <HowItWorks />
        <InspirationGallery />
        <BottomCTA />
      </main>
      <Footer />
    </div>
  );
}